import { useState } from 'react';
import ProjectImage from './ProjectImage';
import ProjectContent from './ProjectContent';

export default function ProjectCard({ project, projectIndex }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(prev => !prev);
  };

  return (
    <div className="bg-gray-800/50 p-4 rounded-lg border border-emerald-400/20 transition-all duration-300 min-h-48">
      <div className="flex flex-col sm:flex-row gap-4 min-h-full">
        <div className="flex justify-center">
          <ProjectImage 
            src={project.image || "projectImage1.jpg"}
            alt={project.projectTitle}
            title={project.projectTitle}
          />
        </div>
        
        <div className="flex justify-center sm:justify-start sm:text-left">
          <ProjectContent 
            project={project}
            isExpanded={isExpanded}
            onToggleExpanded={toggleExpanded}
          />
        </div>
      </div>
    </div>
  );
}